const CNG_ADMIN_URL = `${process.env.REACT_APP_CNG_ADMIN_ORIGIN_URL}`

const CngAdminApiUrls = {
  AUDIT_TRAIL_LISTING: `${CNG_ADMIN_URL}/cng-admin/audit-header/get`,
  AUDIT_TRAIL_COMPARE: `${CNG_ADMIN_URL}/cng-admin/audit-header/compare`  
}

export default CngAdminApiUrls